module.exports = __webpack_public_path__ + "media/home.mp4";